import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"
import { BuildingType } from "shared/types/references/BuildingType"
import { RoomType } from "shared/types/references/RoomType"

export const ProductObjClass = Scrivito.provideObjClass("Product", {
  attributes: {
    ...defaultPageAttributes,
    titleShort: "string",
    descriptionShort: "string",
    kind: "string",
    productType: "string",
    roomTypes: ["multienum", { values: Object.values(RoomType) }],
    buildingTypes: ["multienum", { values: Object.values(BuildingType) }],
    attributes: "stringlist",
    variantKey: "string",
    expertAttributes: "stringlist",
    hiddenAttributes: "stringlist",
    standardConfiguration: "string",
    hideConfigurationPresets: "boolean",
    addons: ["referencelist", { only: ["ProductAddonWrapper"] }],
    references: ["referencelist", { only: ["BuildingReference"] }],
    image: ["reference", { only: "Image" }],
    imageWidgets: ["widgetlist", { only: "ImageWidget" }],
    childOrder: "referencelist",
    automaticBuildingReferences: "boolean",
    isConfigurationWIP: "boolean",
    isHiddenInPortfolio: "boolean",
    productDescription: "stringlist",
    attributeInformation: [
      "referencelist",
      { only: ["AttributeInformationWrapper"] }
    ]
  },
  onlyChildren: ["ProductBaseVariant"]
})

export type ProductObj = InstanceType<typeof ProductObjClass>
export type ProductAttributes = ScrivitoAttributes<ProductObj>
